import {HTTP} from "@/helpers/http-common";

const get = (combo) =>new Promise((resolve,reject)=>{
  const {tipo} = combo;
  HTTP.get(
    `/api/combos/${tipo}`
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});

//Export methods
export default {
  get
}





// WEBPACK FOOTER //
// ./src/services/catalogos/index.js